import React, {useEffect, useState} from 'react';
import IntlMessage, {IntlMessageText} from "../../../../../components/IntlMessage/IntlMessage";
import {Button, Card, Divider, Flex, Form, Input, message, Modal, Radio, Table} from "antd";
import classes from "../../Applications/application.module.css";
import CertificateService from "../../../../../services/CertificateService";
import MyText from "../../../../../components/UI/Text/MyText";
import {Document, Page} from "react-pdf";
import {API_BASE_URL} from "../../../../../constants/api";
import GreyButton from "../../../../../components/UI/Buttons/GreyButton";
import {useDispatch, useSelector} from "react-redux";
import {getAllCertificates} from "../../../../../store/slices/CertificateSlice";
import BlockLoading from "../../../../../components/LoadingComponents/BlockLoading";
import debounce from "lodash/debounce";
import {PlusOutlined} from "@ant-design/icons";
import {LocalName} from "../../../../../utils/LocalName";

const CertificateList = () => {
    const dispatch = useDispatch();
    const {certificates, isLoading, hasMore, error} = useSelector(state => state.certificateList)
    const categoriesList = useSelector(state => state.categoriesList);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(30);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);

    const [initialLoading, setInitialLoading] = useState(true);


    const [viewCertificate, setViewCertificate] = useState(false)
    const [openViewCertificate, setOpenViewCertificate] = useState(false)
    const [certificateNumPages, setCertificateNumPages] = useState();
    const [certificatePageNumber, setCertificatePageNumber] = useState(1);

    const [searchForm] = Form.useForm();
    const [searchParams, setSearchParams] = useState({ username: '', issueDate: '' });

    useEffect(() => {
        const debouncedFetch = debounce(() => {
            dispatch(getAllCertificates({
                page: currentPage,
                limit: pageSize,
                categoryId: selectedCategoryId,
                ...searchParams,
            }));
        }, 500); // 500ms debounce

        debouncedFetch();

        return () => {
            debouncedFetch.cancel();
        };
    }, [searchParams, currentPage, pageSize, selectedCategoryId]);

    useEffect(() => {
        setCurrentPage(1);
    }, [pageSize]);

    const columns = [
        {
            title: <IntlMessage id={'certificate.code'}/>,
            render: (_, record) => (
                <p>{record.code}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'group'} />,
            render: (_, record) => (
                <p>{record?.groupName !== null ? record.groupName : ""}</p>
            ),
            width: '20%',
        },
        {
            title: <IntlMessage id={'certificate.user'}/>,
            render: (_, record) => (
                <p>{record.user !== null ? (!!record?.user?.profile ? record.user.profile.fullName : record.user.username) : ""}</p>
            ),
            width: '20%',
        },
        {
            title: <IntlMessage id={'certificate.issueDate'}/>,
            render: (_, record) => (
                <p>{new Date(record.date).toLocaleDateString()}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'certificate.expirationDate'}/>,
            render: (_, record) => (
                <p>{new Date(record.expirationDate).toLocaleDateString()}</p>
            ),
            width: '10%',
        },
        {
            title: <IntlMessage id={'rectorSignature'}/>,
            render: (_, record) => (
                <p>{record.signature !== null ? <PlusOutlined /> : ""}</p>
            ),
            width: '5%',
        },
        {
            title: <IntlMessage id={'actions'}/>,
            render: (_, record) => (
                <>
                    {
                        <Flex style={{width: "100%"}} align={"center"} justify={"center"} wrap={"wrap"} gap={20}>
                            <p onClick={() => {
                                setViewCertificate(record);
                                setOpenViewCertificate(true);
                            }} className={classes.copyLinkBtn}><IntlMessage id={'view'}/></p>
                            <p onClick={() => downloadDocument(record?.id, record)}
                               className={classes.copyLinkBtn}><IntlMessage id={'download'}/></p>

                        </Flex>
                    }
                </>
            ),
            width: '10%',
        },
    ];

    const handlePaginationChange = (page, pageSize) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    }

    function onDocumentLoadSuccess({numPages}: { numPages: number }): void {
        setCertificateNumPages(numPages);
    }

    function triggerDownload(blob, filename) {
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename); // Set the download attribute with a filename
        document.body.appendChild(link);
        link.click();

        // Clean up and revoke the URL after download
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    async function downloadDocument(documentId, certificate) {
        message.loading(<IntlMessage id={'loading'}/>, 0);
        // await CertificateService.getTestResourceById()
        await CertificateService.getResourceById(certificate?.code)
            .then((r) => {
                message.destroy();
                message.success(<IntlMessage id={'success'}/>, 5);

                triggerDownload(r.data, certificate?.certificateTemplate?.name + " Certificate.pdf")
            })
            .catch(() => {
                message.destroy();
                message.error(<IntlMessage id={'error'}/>, 5);
            })
    }

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={20} vertical>
            <Card style={{width: "100%", borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)'}}>
                <Flex style={{width: "100%"}} vertical align={"flex-start"} justify={"flex-start"}>
                    {/*<Divider orientation="left" style={{fontWeight: 600}}>*/}
                    {/*    <IntlMessage id={'filter'}/>*/}
                    {/*</Divider>*/}
                    <Radio.Group
                        value={selectedCategoryId}
                        onChange={(e) => {
                            setSelectedCategoryId(e.target.value);
                            setCurrentPage(1);
                        }}
                    >
                        <Radio value={null}>
                            <IntlMessage id={'allCategories'}/>
                        </Radio>
                        {
                            categoriesList?.categories?.map((category) => (
                                <Radio value={category.id} key={category.id}>
                                    {LocalName.getName(category)}
                                </Radio>
                            ))
                        }
                    </Radio.Group>
                </Flex>
            </Card>
            <Flex style={{width: "100%"}} vertical align={"flex-start"} justify={"flex-start"}>
                <Form form={searchForm} layout="inline" style={{ marginBottom: 16 }}>
                    <Form.Item name="username">
                        <Input
                            placeholder={IntlMessageText.getText({id: "name"})}
                            onChange={e => {
                                setSearchParams(prev => ({ ...prev, username: e.target.value }));
                                setCurrentPage(1);
                            }}
                        />
                    </Form.Item>
                    <Form.Item name="issueDate">
                        <Input
                            type="date"
                            onChange={e => {
                                setSearchParams(prev => ({ ...prev, issueDate: e.target.value }));
                                setCurrentPage(1);
                            }}
                        />
                    </Form.Item>
                </Form>
            </Flex>
            <BlockLoading isLoading={isLoading}/>
            <Table
                bordered
                columns={columns}
                dataSource={certificates}
                pagination={{
                    current: currentPage,
                    total: hasMore
                        ? currentPage * pageSize + 1
                        : currentPage * pageSize,
                    defaultPageSize: pageSize,
                    showSizeChanger: true,
                    pageSize: pageSize,
                    pageSizeOptions: ['5', '10', '20', '30', '50', '100'],
                    onChange: handlePaginationChange,
                    // onShowSizeChange: handlePaginationChange,
                }}
                rowKey={record => record.id}
                loading={isLoading}
                style={{
                    width: "100%",
                }}
                scroll={{x: 800}}
            />
            <Modal
                width={800}
                maskClosable={true}
                // title={<IntlMessage id={'contractsPage.details'}/>}
                open={openViewCertificate}
                okText={<IntlMessage id={'save'}/>}
                cancelText={<IntlMessage id={'close'}/>}
                style={{
                    top: 20,
                }}
                onOk={() => {
                    setOpenViewCertificate(false)
                }}
                onCancel={() => {
                    setOpenViewCertificate(false)
                }}
                footer={[
                    <Button key="submit" type="primary" onClick={() => {
                        setOpenViewCertificate(false)
                    }}>
                        OK
                    </Button>
                ]}
            >
                {
                    viewCertificate &&
                    <Flex gap={50}
                          style={{
                              width: "100%",
                              minHeight: "calc(100vh - 300px)",
                              position: "relative",
                              padding: "0px 20px 20px 0px",
                          }}
                          vertical
                          align={"flex-start"}
                          justify={"flex-start"}>
                        <Flex align={"center"} justify={"center"} vertical
                              style={{overflowX: "auto", overflowY: "hidden", width: "100%"}}>
                            <Flex style={{
                                zIndex: 1,
                                padding: "10px 20px",
                                backgroundColor: "white",
                                borderRadius: 10,
                                boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.1)",
                            }} gap={15} justify={"space-between"} align={"center"}>
                                <Button disabled={certificatePageNumber === 1} onClick={() => {
                                    setCertificatePageNumber(certificatePageNumber - 1)
                                }}>
                                    {'<'}
                                </Button>
                                <MyText size={"small"}>
                                    {certificatePageNumber} / {certificateNumPages}
                                </MyText>
                                <Button disabled={certificatePageNumber === certificateNumPages} onClick={() => {
                                    setCertificatePageNumber(certificatePageNumber + 1)
                                }}>
                                    {'>'}
                                </Button>
                            </Flex>
                            <Document file={API_BASE_URL + "/api/certificate/resource/code/" + viewCertificate?.code}
                                      onLoadSuccess={onDocumentLoadSuccess}
                                      loading={<IntlMessage id={'documentIsLoading'}/>}
                            >
                                <Page pageNumber={certificatePageNumber} width={700}/>
                            </Document>
                        </Flex>
                        <Flex align={"flex-start"} justify={"center"} gap={20} style={{width: "100%"}}>
                            <GreyButton onClick={() => downloadDocument(viewCertificate?.code, viewCertificate)}>
                                <IntlMessage id={'download'}/>
                            </GreyButton>
                        </Flex>
                    </Flex>
                }
            </Modal>
        </Flex>
    );
};

export default CertificateList;